import React, { createContext, useContext } from "react";

// Create the context with default styles
const HrContext = createContext();

// Provider component that will pass down the HR styles
export const HrProvider = ({ children }) => {
  const hrStyles = {
    width: "70%",
    margin: "0 auto",
    border: "none",
    height: "1px",
    background: "linear-gradient(to right, white, black, white)"
  };

  return (
    <HrContext.Provider value={hrStyles}>
      {children}
    </HrContext.Provider>
  );
};

// Custom hook to use the HR context
export const useHrStyles = () => useContext(HrContext);
